/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Display state of a projected workflow step. Distinct from @see {@link Synqo.Cloud.AgenticOrchestrator.Model.Api.EnumWorkflowStepOutcome},
 * which records what a step that actually ran did: a projected row also covers steps that have not
 * run, or never will because the run took another branch.
 */
export enum EnumWorkflowStepStatus {
    /**
     * Not started. The only status a preview ever produces.
     */
    Pending = 0,
    /**
     * Currently executing.
     */
    Running = 1,
    /**
     * Finished successfully.
     */
    Done = 2,
    /**
     * Blocked on the user: a <c>Question</c> or a pending approval.
     */
    WaitingForUser = 3,
    /**
     * On a branch the run did not take.
     */
    Skipped = 4,
    /**
     * The action threw.
     */
    Failed = 5,
}
